/**
 * Staffelpreis PDP-Sync (Birmelin) v2
 *
 * Zaehlt den Gesamtpreis auf der Produktseite hoch, basierend auf der sichtbaren
 * Staffeltabelle ("MENGE | PREIS PRO STK | GESAMT", gerendert von BSS/pricebazi).
 *
 * Fix ggue. v1:
 *   Bei 3-Spalten-Tabellen wird der Stueckpreis jetzt aus der MITTLEREN Spalte
 *   gelesen (Preis pro Stueck), nicht aus der letzten Spalte (= Gesamt).
 *   Der angezeigte Gesamtpreis wird - wie bei Cerion - proportional aus der
 *   Gesamt-Spalte hochskaliert, damit die BSS-Rundung 1:1 erhalten bleibt.
 *
 * Ergebnis-Format: "€Gesamt inkl. MwSt. (€Stueckpreis / Stueck × Menge)".
 *
 * VAT_MULTIPLIER:
 *   1.0  = Tabellenpreis unveraendert uebernehmen (Tabelle zeigt bereits brutto).
 *   1.19 = Tabellenpreise sind netto und sollen brutto angezeigt werden.
 */
(function () {
  'use strict';

  var VAT_MULTIPLIER = 1.0;
  var PRICE_SUFFIX = ' inkl. MwSt.';

  // ── Helpers ────────────────────────────────────────────────────────────────

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null) {
      var s0 = window.getComputedStyle(el);
      if (s0.position !== 'fixed') return false;
    }
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return false;
    return el.offsetWidth > 0 && el.offsetHeight > 0;
  }

  // "€0,71" / "0,71 €" / "€1.234,56" -> Cent (Integer); erster Betrag im Text.
  function parsePriceCents(text) {
    if (!text) return null;
    var m = text.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+)[.,](\d{2})(?!\d)/);
    if (!m) return null;
    var whole = m[1].replace(/[.\s]/g, '');
    var val = parseInt(whole, 10) * 100 + parseInt(m[2], 10);
    if (isNaN(val) || val <= 0) return null;
    return val;
  }

  // Alle Betraege im Text als Cent-Liste.
  function parsePriceCentsAll(text) {
    if (!text) return [];
    var re = /(\d{1,3}(?:[.\s]\d{3})*|\d+)[.,](\d{2})(?!\d)/g, m, out = [];
    while ((m = re.exec(text)) !== null) {
      var val = parseInt(m[1].replace(/[.\s]/g, ''), 10) * 100 + parseInt(m[2], 10);
      if (!isNaN(val) && val > 0) out.push(val);
    }
    return out;
  }

  // Brutto-Betrag einer Zelle. Bevorzugt den Betrag, der mit inkl./inc./MwSt./VAT
  // ausgezeichnet ist (Brutto). Steht nur ein Betrag da, wird dieser genommen.
  // Faengt den Fall ab, dass BSS netto UND brutto in dieselbe Zelle rendert.
  function parseGrossCents(text) {
    if (!text) return null;
    var g = text.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+)[.,](\d{2})(?!\d)\s*(?:€|EUR)?\s*(?:inkl|incl|inc|mwst|vat)/i);
    if (g) return parseInt(g[1].replace(/[.\s]/g, ''), 10) * 100 + parseInt(g[2], 10);
    var all = parsePriceCentsAll(text);
    return all.length ? all[all.length - 1] : null;
  }

  // "50 - 199" / "ab 50" / "Buy 50" / "1.000" -> 50 / 50 / 50 / 1000
  function parseMinQty(text) {
    if (!text) return null;
    var m = text.match(/\d[\d.\s]*/);
    if (!m) return null;
    var n = parseInt(m[0].replace(/[.\s]/g, ''), 10);
    return (isNaN(n) || n <= 0) ? null : n;
  }

  function formatPrice(cents) {
    var euro = (cents / 100).toFixed(2);
    var parts = euro.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '\u20ac' + parts[0] + ',' + parts[1];
  }

  // ── Tabelle finden + Tiers lesen ────────────────────────────────────────────

  function rowsToTiers(rows) {
    var tiers = [];
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('td, th');
      if (cells.length < 2) return;

      var min = parseMinQty(cells[0].textContent);
      if (min === null) return; // Header-/Leerzeile

      var unit = null;
      var total = null;

      if (cells.length >= 3) {
        // 3 Spalten: Menge | Preis pro Stueck | Gesamt -> jeweils Brutto lesen
        unit = parseGrossCents(cells[1].textContent);
        total = parseGrossCents(cells[cells.length - 1].textContent);
        // Fallback, falls die mittlere Spalte ausnahmsweise keinen Preis enthaelt:
        // ersten Brutto-Treffer zwischen erster und letzter Spalte nehmen.
        if (unit === null) {
          for (var i = 1; i < cells.length - 1; i++) {
            unit = parseGrossCents(cells[i].textContent);
            if (unit !== null) break;
          }
        }
      } else {
        // 2 Spalten: Menge | Preis pro Stueck
        unit = parseGrossCents(cells[cells.length - 1].textContent);
      }

      if (unit === null) return;

      tiers.push({
        min: min,
        unit: Math.round(unit * VAT_MULTIPLIER),
        total: (total === null) ? null : Math.round(total * VAT_MULTIPLIER)
      });
    });

    // nach Mindestmenge sortieren, Duplikate (gleiche min) zusammenfassen
    tiers.sort(function (a, b) { return a.min - b.min; });
    var out = [];
    tiers.forEach(function (t) {
      if (!out.length || out[out.length - 1].min !== t.min) out.push(t);
    });
    return out;
  }

  function findTierTable() {
    var tables = document.querySelectorAll('table');
    var best = null;
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i];
      if (t.closest('#Cart-Drawer') || t.closest('cart-drawer')) continue;
      var rows = t.querySelectorAll('tr');
      var tiers = rowsToTiers(rows);
      if (tiers.length >= 1 && isVisible(t)) return { el: t, tiers: tiers };
      if (tiers.length >= 1 && !best) best = { el: t, tiers: tiers };
    }
    if (best) return best;

    // Fallback: nicht-table Container mit Zeilen, die Menge + Preis enthalten
    var containers = document.querySelectorAll('[class*="tier"], [class*="qty"], [class*="quantity-break"], [class*="volume"], [class*="staffel"], [id*="pricebazi"], [class*="pricebazi"]');
    for (var c = 0; c < containers.length; c++) {
      var cont = containers[c];
      if (cont.closest('#Cart-Drawer') || cont.closest('cart-drawer')) continue;
      var divRows = cont.querySelectorAll(':scope > div, :scope > li, :scope tr');
      var tiers2 = [];
      divRows.forEach(function (r) {
        var min = parseMinQty(r.textContent);
        var unit = parseGrossCents(r.textContent); // Brutto-Stueckpreis
        if (min !== null && unit !== null) {
          tiers2.push({ min: min, unit: Math.round(unit * VAT_MULTIPLIER), total: null });
        }
      });
      tiers2.sort(function (a, b) { return a.min - b.min; });
      if (tiers2.length >= 1 && isVisible(cont)) return { el: cont, tiers: tiers2 };
    }
    return null;
  }

  function tierForQty(tiers, qty) {
    var match = tiers[0] || null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].min) match = tiers[i];
    }
    return match;
  }

  // ── Qty-Input + Preis-Elemente (PDP) ────────────────────────────────────────

  function findQtyInput() {
    var inputs = document.querySelectorAll('input.qty, input[name="quantity"]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (el.closest('#Cart-Drawer') || el.closest('cart-drawer') ||
          el.closest('.product-modal') || el.closest('modal-dialog')) continue;
      if (isVisible(el) || inputs.length === 1) return el;
    }
    return inputs.length ? inputs[0] : null;
  }

  function priceTargets() {
    function collect(sel) {
      var out = [];
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('#Cart-Drawer') || el.closest('cart-drawer') ||
            el.closest('.product-modal') || el.closest('modal-dialog')) return;
        out.push(el);
      });
      return out;
    }
    var anchored = collect('[bss-b2b-product-price]');
    if (anchored.length) return anchored;
    return collect('.product--title-container .product--price-container .price');
  }

  // ── Sync ────────────────────────────────────────────────────────────────────

  var lastKey = '';

  function buildHtml(totalCents, unitCents, qty) {
    return '<ins><span class="amount" style="font-size:inherit">' +
      formatPrice(totalCents) + PRICE_SUFFIX + '</span></ins>' +
      '<small style="display:block;font-size:0.85rem;color:#666;font-weight:400;margin-top:2px">(' +
      formatPrice(unitCents) + ' / St\u00fcck \u00d7 ' + qty + ')</small>';
  }

  function sync() {
    var found = findTierTable();
    if (!found || !found.tiers.length) return;
    var input = findQtyInput();
    if (!input) return;
    var qty = parseInt(input.value, 10) || 0;
    if (qty <= 0) return;
    var tier = tierForQty(found.tiers, qty);
    if (!tier) return;

    // Gesamtpreis: aus der Gesamt-Spalte proportional hochskalieren (erhaelt BSS-Rundung),
    // sonst Fallback Stueckpreis × Menge.
    var totalCents;
    if (tier.total && tier.min > 0) {
      totalCents = Math.round(tier.total / tier.min * qty);
    } else {
      totalCents = tier.unit * qty;
    }

    var key = qty + ':' + tier.unit + ':' + tier.total + ':' + found.tiers.length;
    if (key === lastKey) return;
    lastKey = key;

    var html = buildHtml(totalCents, tier.unit, qty);
    priceTargets().forEach(function (el) {
      el.innerHTML = html;
      el.style.visibility = 'visible';
    });
  }

  // ── Listener + Init ─────────────────────────────────────────────────────────

  function attachInput() {
    var input = findQtyInput();
    if (!input || input._staffelPdp) return;
    input._staffelPdp = true;
    ['change', 'input', 'keyup'].forEach(function (evt) {
      input.addEventListener(evt, function () { lastKey = ''; setTimeout(sync, 20); });
    });
  }

  function attachButtons() {
    document.querySelectorAll('quantity-selector .minus, quantity-selector .plus').forEach(function (btn) {
      if (btn._staffelPdp) return;
      btn._staffelPdp = true;
      btn.addEventListener('click', function () { lastKey = ''; setTimeout(sync, 30); setTimeout(sync, 120); });
    });
  }

  function init() {
    attachInput();
    attachButtons();
    sync();

    document.addEventListener('product:variant-change', function () {
      lastKey = '';
      [50, 200, 500, 1000].forEach(function (d) { setTimeout(sync, d); });
    });

    new MutationObserver(function () {
      attachInput();
      attachButtons();
      sync();
    }).observe(document.body, { childList: true, subtree: true });

    var poll = setInterval(function () { attachInput(); attachButtons(); sync(); }, 400);
    setTimeout(function () { clearInterval(poll); }, 60000);

    [200, 600, 1200, 2500].forEach(function (d) {
      setTimeout(function () { attachInput(); attachButtons(); sync(); }, d);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
